import createReducer from './_createReducerHelper';

// branding
export const LOGO = 'layout/LOGO';
export const BRAND_PRIMARY_COLOR = 'layout/BRAND_PRIMARY_COLOR';
export const BRAND_SECONDARY_COLOR = 'layout/BRAND_SECONDARY_COLOR';

// page switches
export const SHOW_UC_LICENSE_PAGE = 'layout/SHOW_UC_LICENSE_PAGE';
export const SHOW_NO_SERVICE_PAGE = 'layout/SHOW_NO_SERVICE_PAGE';
export const SHOW_BROWSER_SUPPORT_PAGE = 'layout/SHOW_BROWSER_SUPPORT_PAGE';
export const SHOW_FORGOT_LOGIN_PAGE = 'layout/SHOW_FORGOT_LOGIN_PAGE';
export const SHOW_FORGOT_PASSWORD_PAGE = 'layout/SHOW_FORGOT_PASSWORD_PAGE';
export const SHOW_PASSWORD_RESET_PAGE = 'layout/SHOW_PASSWORD_RESET_PAGE';
export const SHOW_LOADER_PAGE = 'layout/SHOW_LOADER_PAGE';
export const SHOW_LOGIN_FORM_PAGE = 'layout/SHOW_LOGIN_FORM_PAGE';
export const SHOW_SUBSCRIBER_SELECT_PAGE = 'layout/SHOW_SUBSCRIBER_SELECT_PAGE';
export const SHOW_SSO_ENROLL_PAGE = 'layout/SHOW_SSO_ENROLL_PAGE';
export const SHOW_MFA_FORM_PAGE = 'layout/SHOW_MFA_FORM_PAGE';
export const SHOW_WRAPPER_PAGE = 'layout/SHOW_WRAPPER_PAGE';
export const SHOW_WRAPPER_PAGE_PUBLIC = 'layout/SHOW_WRAPPER_PAGE_PUBLIC';

// mode & state toggles
export const IS_LOADING = 'layout/IS_LOADING';
export const EDIT_MODE = 'layout/EDIT_MODE';
export const PUBLIC_MODE = 'layout/PUBLIC_MODE';
export const VIEW_ONLY = 'layout/VIEW_ONLY';

// is open flags
export const SHOW_LEFT_SIDEBAR = 'layout/SHOW_LEFT_SIDEBAR';
export const SHOW_RIGHT_SIDEBAR = 'layout/SHOW_RIGHT_SIDEBAR';
export const SHOW_SHARE_DIALOG = 'layout/SHOW_SHARE_DIALOG';
export const SHOW_BOARD_SETTINGS_DIALOG = 'layout/SHOW_BOARD_SETTINGS_DIALOG';
export const SHOW_FILTER_OVERRIDE_DIALOG = 'layout/SHOW_FILTER_OVERRIDE_DIALOG';
export const SHOW_TOASTER = 'layout/SHOW_TOASTER';

const initialState = {
  brandPrimaryColor: '#3F51B5',
  brandSecondaryColor: '#F49F0A',

  // page toggles
  showBrowserSupportPage: false,
  showUCLicensePage: false,
  showNoServicePage: false,
  showForgotLoginPage: false,
  showForgotPasswordPage: false,
  showPasswordResetPage: false,
  showLoaderPage: false,
  showLoginFormPage: false,
  showSubscriberSelectPage: false,
  showSsoEnrollPage: false,
  showMfaFormPage: false,
  showWrapperPage: false,

  // general toggles
  isLoading: false,

  // mode toggles
  editMode: false,
  publicMode: false,
  viewOnly: false,

  // sidebar toggles
  showLeftSidebar: false,
  showRightSidebar: false,

  // dialog toggles
  showShareDialog: false,
  showBoardSettingsDialog: false,
  showFilterOverrideDialog: false,

  // toaster toggles
  showToaster: {
    show: false,
    message: '',
    type: '',
    action: null,
  },
};

/** ********************************************
 * reducer
 ******************************************** */

const initialWithTheme = (state) => ({
  ...initialState,
  logo: state.logo,
  brandPrimaryColor: state.brandPrimaryColor,
  brandSecondaryColor: state.brandSecondaryColor,
});

export default createReducer(initialState, {
  [LOGO]: (state, { payload }) => ({ ...state, logo: payload }),
  [BRAND_PRIMARY_COLOR]: (state, { payload }) => ({ ...state, brandPrimaryColor: payload }),
  [BRAND_SECONDARY_COLOR]: (state, { payload }) => ({ ...state, brandSecondaryColor: payload }),
  [SHOW_UC_LICENSE_PAGE]: (state, { payload }) => ({ ...initialWithTheme(state), showUCLicensePage: payload }),
  [SHOW_BROWSER_SUPPORT_PAGE]: (state) => ({ ...initialWithTheme(state), showBrowserSupportPage: true }),
  [SHOW_FORGOT_LOGIN_PAGE]: (state) => ({ ...initialWithTheme(state), showForgotLoginPage: true }),
  [SHOW_FORGOT_PASSWORD_PAGE]: (state) => ({ ...initialWithTheme(state), showForgotPasswordPage: true }),
  [SHOW_PASSWORD_RESET_PAGE]: (state) => ({ ...initialWithTheme(state), showPasswordResetPage: true }),
  [SHOW_LOADER_PAGE]: (state) => ({ ...initialWithTheme(state), showLoaderPage: true }),
  [SHOW_LOGIN_FORM_PAGE]: (state) => ({ ...initialWithTheme(state), showLoginFormPage: true }),
  [SHOW_SUBSCRIBER_SELECT_PAGE]: (state, { payload }) => ({
    ...initialWithTheme(state), showSubscriberSelectPage: payload,
  }),
  [SHOW_SSO_ENROLL_PAGE]: (state, { payload }) => ({ ...initialWithTheme(state), showSsoEnrollPage: payload }),
  [SHOW_MFA_FORM_PAGE]: (state, { payload }) => ({ ...initialWithTheme(state), showMfaFormPage: payload }),
  [SHOW_WRAPPER_PAGE]: (state, { payload }) => ({ ...initialWithTheme(state), showWrapperPage: payload }),
  [SHOW_WRAPPER_PAGE_PUBLIC]: (state, { payload }) => ({
    ...initialWithTheme(state), showWrapperPage: payload, publicMode: true,
  }),
  [IS_LOADING]: (state, { payload }) => ({ ...state, isLoading: payload }),
  [EDIT_MODE]: (state, { payload }) => ({ ...state, editMode: payload }),
  [PUBLIC_MODE]: (state, { payload }) => ({ ...state, publicMode: payload }),
  [VIEW_ONLY]: (state, { payload }) => ({ ...state, viewOnly: payload }),
  [SHOW_LEFT_SIDEBAR]: (state, { payload }) => ({ ...state, showLeftSidebar: payload }),
  [SHOW_RIGHT_SIDEBAR]: (state, { payload }) => ({ ...state, showRightSidebar: payload }),
  [SHOW_SHARE_DIALOG]: (state, { payload }) => ({ ...state, showShareDialog: payload }),
  [SHOW_BOARD_SETTINGS_DIALOG]: (state, { payload }) => ({ ...state, showBoardSettingsDialog: payload }),
  [SHOW_FILTER_OVERRIDE_DIALOG]: (state, { payload }) => ({ ...state, showFilterOverrideDialog: payload }),
  [SHOW_TOASTER]: (state, { payload }) => ({ ...state, showToaster: payload }),
  [SHOW_NO_SERVICE_PAGE]: (state) => ({ ...initialWithTheme(state), showNoServicePage: true }),
});

/** ********************************************
 * actions
 ******************************************** */

/**
 *
 * @param logo
 * @return {{type: string, payload: *}}
 */
export const setLogo = (logo) => ({
  type: LOGO,
  payload: logo,
});

/**
 *
 * @param color
 * @return {{type: string, payload: *}}
 */
export const setBrandPrimaryColor = (color) => ({
  type: BRAND_PRIMARY_COLOR,
  payload: color,
});

/**
 *
 * @param color
 * @return {{type: string, payload: *}}
 */
export const setBrandSecondaryColor = (color) => ({
  type: BRAND_SECONDARY_COLOR,
  payload: color,
});

/**
 *
 * @param notice
 * @return {{type, payload: *}}
 */
export const showUCLicenseMsgPage = (notice) => ({
  type: SHOW_UC_LICENSE_PAGE,
  payload: notice,
});

/**
 *
 * @return {{type}}
 */
export const showBrowserSupportPage = () => ({ type: SHOW_BROWSER_SUPPORT_PAGE });

/**
 *
 * @return {{type}}
 */
export const showForgotLoginPage = () => ({ type: SHOW_FORGOT_LOGIN_PAGE });

/**
 *
 * @return {{type}}
 */
export const showForgotPasswordPage = () => ({ type: SHOW_FORGOT_PASSWORD_PAGE });

/**
 *
 * @return {{type}}
 */
export const showPasswordResetPage = () => ({ type: SHOW_PASSWORD_RESET_PAGE });

/**
 *
 * @return {{type}}
 */
export const showLoaderPage = () => ({ type: SHOW_LOADER_PAGE });

/**
 *
 * @return {{type}}
 */
export const showLoginFormPage = () => ({ type: SHOW_LOGIN_FORM_PAGE });

/**
 *
 * @return {{type}}
 */
export const showNoServicePage = () => ({ type: SHOW_NO_SERVICE_PAGE });

/**
 *
 * @param subscriberList
 * @return {{type}}
 */
export const showSubscriberSelectPage = (subscriberList) => ({
  type: SHOW_SUBSCRIBER_SELECT_PAGE,
  payload: subscriberList,
});

/**
 *
 * @param idtoken
 * @param vendor
 * @return {{type}}
 */
export const showSsoEnrollPage = (idtoken, vendor) => ({
  type: SHOW_SSO_ENROLL_PAGE,
  payload: { idtoken, vendor },
});

/**
 *
 * @param username
 * @param mfaType
 * @param mfaVendor
 * @return {{type}}
 */
export const showMfaFormPage = (username, mfaType, mfaVendor) => ({
  type: SHOW_MFA_FORM_PAGE,
  payload: { username, mfa_type: mfaType, mfa_vendor: mfaVendor },
});

/**
 *
 * @param bool
 * @return {{type: string, payload: *}}
 */
export const showWrapperPage = (bool) => ({
  type: SHOW_WRAPPER_PAGE,
  payload: bool,
});

/**
 *
 * @param bool
 * @return {{type: string, payload: *}}
 */
export const showWrapperPagePublic = (bool) => ({
  type: SHOW_WRAPPER_PAGE_PUBLIC,
  payload: bool,
});

/**
 *
 * @param bool
 * @return {{type: string, payload: *}}
 */
export const isLoading = (bool) => ({
  type: IS_LOADING,
  payload: bool,
});

/**
 *
 * @param bool
 * @return {{type: string, payload: *}}
 */
export const editMode = (bool) => ({
  type: EDIT_MODE,
  payload: bool,
});

/**
 *
 * @param bool
 * @return {{type: string, payload: *}}
 */
export const publicMode = (bool) => ({
  type: PUBLIC_MODE,
  payload: bool,
});

/**
 *
 * @param bool
 * @return {{type: string, payload: *}}
 */
export const viewOnly = (bool) => ({
  type: VIEW_ONLY,
  payload: bool,
});

/**
 *
 * @param bool
 * @return {{type: string, payload: *}}
 */
export const showLeftSidebar = (bool) => ({
  type: SHOW_LEFT_SIDEBAR,
  payload: bool,
});

/**
 *
 * @param bool
 * @return {{type: string, payload: *}}
 */
export const showRightSidebar = (bool) => ({
  type: SHOW_RIGHT_SIDEBAR,
  payload: bool,
});

/**
 *
 * @param bool
 * @return {{type: string, payload: *}}
 */
export const showShareDialog = (bool) => ({
  type: SHOW_SHARE_DIALOG,
  payload: bool,
});

/**
 *
 * @param bool
 * @return {{type: string, payload: *}}
 */
export const showBoardSettingsDialog = (bool) => ({
  type: SHOW_BOARD_SETTINGS_DIALOG,
  payload: bool,
});

/**
 *
 * @param bool
 * @return {{type: string, payload: *}}
 */
export const showFilterOverrideDialog = (bool) => ({
  type: SHOW_FILTER_OVERRIDE_DIALOG,
  payload: bool,
});

/**
 *
 * @param {*} toaster
 * @return {{type: string, payload: *}}
 */
export const showToaster = (toaster) => ({
  type: SHOW_TOASTER,
  payload: toaster,
});

/** ********************************************
 * selectors
 ******************************************** */

export const selectLayout = (state) => state?.layout;
